export default "__VITE_ASSET__oOOr$iKd__"